<template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto;">
        <el-input style="min-width: 150px;" placeholder="请输入关键字搜索" v-model="keyWord" clearable size="small" class="s_padding filterSelect">
        </el-input>
        <dateRangeHis ref="dateRange"></dateRangeHis>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%">
        <tableCom :data="customerList" v-loading="loading"></tableCom>
      </div>
      <div class="pagination_m2 text-center">
        <pagination :pagerPro="Pager" @ee="pageFn"></pagination>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import tableCom from "./allCustomersT.vue";
import pagination from "../../paging.vue";
import dateRangeHis from "../../dateRangeSubHis.vue";
import SeachConPage from "../SeachConPage.vue";

export default {
  // 筛选器
  name: "allCustomer",
  props: ["agentID"],
  components: {
    tableCom,
    pagination,
    dateRangeHis,
    SeachConPage
  },
  data() {
    return {
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 10,
        RecordCount: 0
      },
      customerList: [],
      totalCapital: 0,
      totalCurrency: 0,
      keyWord: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(isSearch = true) {
      if (isSearch) {
        this.Pager = {
          PageNo: 1,
          PageSize: 20,
          RecordCount: 0
        };
      }
      this.loading = true;
      let url = "/report/QueryAgentInsUsers";
      let postData = {
        AgentIds: this.agentID,
        UserKey: this.keyWord,
        BeginDate: this.$refs.dateRange.DateRangeValue[0],
        EndDate: this.$refs.dateRange.DateRangeValue[1]
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager.PageNo,
        this.Pager.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.customerList = response.Data;
            this.totalCapital = 0;
            this.totalCurrency = 0;
            if (this.Pager.PageNo == 1) {
              this.Pager = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selects/allCustomers/allCustomersS.vue